import CommandTriggerEvent from './CommandTriggerEvent';
import CommandTriggerForwarder from './CommandTriggerForwarder';

class TransformCommand {
    constructor(childTrigger, transformer) {
        if (typeof transformer !== 'object' ||
            !('transform' in transformer) ||
            typeof transformer.transform !== 'function') {
            throw new Error(
                'transformer does not implement the Transformer interface.'
            );
        }

        this.childTrigger = childTrigger;
        this.transformer = transformer;
    }

    run(triggerEvent) {
        const transformedEvent = triggerEvent.copy();
        const newData = this.transformer.transform(triggerEvent);

        transformedEvent.setData(newData);

        this.childTrigger.trigger(transformedEvent);
    }
}

class CommandTriggerSimple {
    constructor(target) {
        this.target = target;
        this.commandList = null;
        this.triggerDomBound = null;
    }

    listen(command) {
        if (typeof command !== 'object' ||
            !('run' in command) ||
            typeof command.run !== 'function') {
            throw new Error('command does not implement the Command interface.');
        }

        if (this.commandList === null) {
            this.commandList = [];
        }

        this.commandList.push(command);
    }

    transform(transformer) {
        const childTrigger = new CommandTriggerSimple(this);

        this.listen(new TransformCommand(childTrigger, transformer));

        return new CommandTriggerForwarder(
            this,
            this.childTrigger
        );
    }

    removeListen(command) {
        if (this.commandList !== null) {
            for (let i = 0; i < this.commandList.length; i++) {
                const currentCommand = this.commandList[i];

                if (command === currentCommand) {
                    this.commandList.splice(i, 1);
                    return;
                }
            }
        }
    }

    trigger(triggerEventOriginal) {
        let triggerEvent = triggerEventOriginal;
        if (triggerEvent === undefined) {
            throw new Error('triggerEvent is a mandatory argument.');
        } else if (triggerEvent === null ||
            !(triggerEvent instanceof CommandTriggerEvent)) {
            const newEvent = new CommandTriggerEvent();

            if (triggerEvent !== null) {
                newEvent.setData(triggerEvent);
            }

            triggerEvent = newEvent;
        }

        triggerEvent = triggerEvent.copy();
        triggerEvent.setTarget(this.target);

        if (this.commandList !== null) {
            for (let i = 0; i < this.commandList.length; i++) {
                const command = this.commandList[i];

                command.run(triggerEvent);
            }
        }
    }

    triggerDom(domEvent) {
        const triggerEvent = new CommandTriggerEvent();

        triggerEvent.setInitiatorEvent(domEvent);
        this.trigger(triggerEvent);
    }

    addDomEventListener(element, eventName) {
        if (this.triggerDomBound === null) {
            this.triggerDomBound = this.triggerDom.bind(this);
        }

        element.addEventListener(
            eventName,
            this.triggerDomBound,
            false
        );
    }

    removeDomEventListener(element, eventName) {
        if (this.triggerDomBound !== null) {
            element.removeEventListener(
                eventName,
                this.triggerDomBound,
                false
            );
        }
    }
}

export default CommandTriggerSimple;

